import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MessageService } from '../../../core/services/messages/messages.service';
import { IMessageEvents } from '../../../constants/events.constants';
import { IconService } from '@shared/common/services/icon/icon.service';

@Component({
  selector: 'app-page-top-navigation',
  templateUrl: './page-top-navigation.component.html',
  styleUrls: ['./page-top-navigation.component.scss'],
  standalone: false
})
export class PageTopNavigationComponent implements OnInit, OnDestroy {
  isVisible = true;
  private readonly _destruction$: Subject<void> = new Subject<void>();

  @Input() title: string;
  @Input() isCompact: boolean;
  @Input() applyOffset: boolean = false;
  @Output() backButtonClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private readonly messagingService: MessageService,
    private readonly iconService: IconService
  ) {}

  ngOnInit() {
    this.overlayMessageBus();
  }

  overlayMessageBus() {
    this.messagingService
      .getOverlayMessage()
      .pipe(takeUntil(this._destruction$))
      .subscribe((message) => {
        const state = {
          [IMessageEvents.SHOW_HEADER]: false,
          [IMessageEvents.HIDE_HEADER]: true
        };

        // set the component z-index by adding a css class so it doesn't overlap with another overlay
        this.isVisible = state[message.text] ?? this.isVisible;
      });
  }

  get backIcon() {
    return this.isCompact ? this.iconService.regular.arrowLeft : this.iconService.regular.chevronLeft;
  }

  goBack() {
    this.backButtonClicked.next(true);
  }

  ngOnDestroy(): void {
    this._destruction$.next();
    this._destruction$.complete();
  }
}
